import { Component, Input, inject } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { DataService } from '../../../services/data.service';

@Component({
	selector: 'app-follow-ups',
	imports: [CommonModule, FormsModule],
  providers: [DatePipe],
	templateUrl: './follow-ups.component.html',
	styleUrl: './follow-ups.component.scss',
})
export class FollowUpsComponent {
	todayFollowUps: any = [];
	overdueFollowUps: any = [];
	followUps: any = [];
	today = new Date().toISOString().split('T')[0];
	datePipe = inject(DatePipe);
  currentDate: Date = new Date();
  localeDate: any = new Date().toLocaleDateString('en-IN');

	base = 'follow_ups';		// important for API calls

  user: any = '';
  errMsg = '';
  okMsg  = '';
  enquiries: any = [];
	follow_ups: any = [];
  users: any = [];
  rec_con_users: any = [];
	inq_id: any = '';

	followUpModes: any = [];
	leadStatuses: any = [];

  filterEnqNo   = '';
  filterStatus  = '';
	editing = false;
	searchText = '';
  currentPage = 1;
  pageSize = 5;
	sortColumn = "id";
	sortDirection = true;
	loading = false;
	isEdit = false;
	counsellors: any = [{'id': 1, 'name': 'Jagmeet'}, {'id': 2, 'name': 'Arun Sharma'}, {'id': 3, 'name': 'Vipin Mehra'}];
  frmData: any = {
    id: null, 
    inq_id: 0, 
    fup_mode: '', 
    fup_notes: '', 
    lead_status: '', 
    fup_date: this.datePipe.transform(this.currentDate, 'yyyy-MM-dd'), 
    next_date: this.datePipe.transform(this.currentDate, 'yyyy-MM-dd'), 
    fup_uid: 0,
    assign_to: 0, 
    assign_by: 0, 
    assign_date: ''
  };
  	
  constructor(public dataService: DataService, private router: Router) {
    //
  }

  ngOnChanges() {
    let erp_rem: any = localStorage.getItem("erp_rem");
    if(erp_rem) {
      erp_rem = JSON.parse(erp_rem);
      erp_rem = this.dataService.deCodeUser(erp_rem);
      this.user = erp_rem;
    }

    this.frmData.inq_id = this.inq_id || 0;
    this.frmData.fup_uid = this.user.id;
  }

  ngOnInit() {
    this.followUpModes = this.dataService.inquiry_mode;
    this.leadStatuses = this.dataService.lead_status;

		this.loading = true;
    this.dataService.getAllRecords('users').then((res: any) => {
      this.users = res;
      for(let i=0; i<res.length; i++) {
        this.users[i].user_role = this.dataService.str2json(this.users[i].user_role);
      }
      
      this.usersRecCon();
      this.loading = false;
    });

		this.loading = true;
    this.dataService.getAllRecords('inquiries').then((res: any) => {
      this.enquiries = res;
      this.loading = false;
    });

		this.loading = true;
    this.dataService.getAllRecords('follow_ups').then((res: any) => {
      this.follow_ups = res;
      this.loading = false;
    });

	}

  usersRecCon() {
    this.rec_con_users = this.users.filter((obj: any) => {
      return obj.user_role[0].code == 'rec' || obj.user_role[0].code == 'con';
    });
  }

	edit(item: any) {
    this.isEdit = true;
		this.frmData = Object.assign({}, item);
	}

  goBack() {
    this.router.navigate(['/dashboard/'+this.dataService.myEncrypt('inq')]);
  }

  sort(column: string) {
    if (this.sortColumn == column) {
      this.sortDirection = !this.sortDirection;
    } else {
      this.sortColumn = column;
      this.sortDirection = true;
    }
  }

	resetForm() {
		this.frmData = {
      id: null, 
      inq_id: 0, 
      fup_mode: '', 
      fup_notes: '', 
      lead_status: '', 
      fup_date: this.datePipe.transform(this.currentDate, 'yyyy-MM-dd'), 
      next_date: this.datePipe.transform(this.currentDate, 'yyyy-MM-dd'), 
      fup_uid: 0,
      assign_to: 0, 
      assign_by: 0, 
      assign_date: ''
    }
  }

  doSave() {
    this.loading = true;
    this.dataService.addNewRecord(this.base, this.frmData).subscribe({
      next: (response) => {
        // set activity log details
				this.dataService.setActivityLog('create', 'inquery', 'New follow up for inquery "'+this.frmData.iname+'" added.');
        // console.log('Response received in component:', response);
        this.isEdit = false;
        this.loading = false;
        // this.resetForm();
      },
      error: (error) => {
        console.error('Error received in component:', error);
        this.loading = false;
      }
    });
  }

  doUpdate() {
    this.loading = true;
		const myid = this.frmData.id;
		delete this.frmData.id;

    this.dataService.updateRecord(this.base, myid, this.frmData).subscribe({
      next: (response) => {
        // set activity log details
				this.dataService.setActivityLog('update', 'inquery', 'Follow up for inquery "'+this.frmData.iname+'" details updated.');
        // console.log('Response received in component:', response);
        this.isEdit = false;
        this.loading = false;
        // this.resetForm();
      },
      error: (error) => {
        console.error('Error received in component:', error);
        this.loading = false;
      }
    });
  }

	async deleteClick(myid: number) {
    const confirmed = await this.dataService.confirmDelete();
    if (confirmed) {
        console.log('Item deleted successfully');
				this.doDelete(myid);
    } else {
        console.log('Deletion cancelled');
    }
	}

  doDelete(myid: number) {
		this.loading = true;
    this.dataService.deleteRecord(this.base, myid).subscribe({
      next: (response) => {
        // console.log('Response received in component:', response);
        // this.delete(myid);
        this.isEdit = false;
				this.loading = false;
        this.ngOnInit();
      },
      error: (error) => {
        console.error('Error received in component:', error);
        this.loading = false;
      }
    });
	}

}
